angular.module("vgresiduos").factory("hotjarService", [
	"accountService",
	"$window",
	function (accountService, $window) {
		"use strict";

		const _identify = function identify() {
			if (!$window.hj) {
				return;
			}

			const user = accountService.getLoggedAccount();
			const currentOrganizationUnit = accountService.getCurrentClient();

			let userId = null;
			let userEmail = null;
			let currentOrganization = null;
			let currentOrganizationUnitId = null;
			let jobAreaDescription = null;
			let jobDescription = null;
			if (user) {
				userId = user.code;
				userEmail = user.email;
				jobDescription = user.jobPosition?.description ?? null;
				jobAreaDescription = user.jobPositionArea?.description ?? null;
			}
			if (currentOrganizationUnit && currentOrganizationUnit.organization) {
				currentOrganization = currentOrganizationUnit.organization.id;
				currentOrganizationUnitId = currentOrganizationUnit.id;
			}

			$window.hj("identify", userId, {
				email: userEmail,
				organization: currentOrganization,
				organizationUnit: currentOrganizationUnitId,
				jobDescription,
				jobAreaDescription
			});
		};

		return {
			identify: _identify
		};
	}
]);
